/**
 * Подключение офлайн-оболочки.
 *
 * Регистрируем тихо: если браузер старый или страница открыта по http —
 * просто работаем без офлайна. Касса не должна падать из-за того,
 * что где-то нет поддержки.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  // Service Worker живёт только на https и localhost
  if (location.protocol !== 'https:' && location.hostname !== 'localhost') return;

  // Область действия — папка приложения: /pos/, /kds/, /menu/
  const scope = location.pathname.replace(/[^/]*$/, '');

  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register(`${scope}sw.js`, { scope })
      .catch(() => undefined);
  });
}
